import getMonetateExperience from './getMonetateExperience';

const getMonetateParams = (features, partialExperienceName) =>
  getMonetateExperience(features, partialExperienceName)?.parameters || {};

export default getMonetateParams;
